/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  BillingEmail,
  BillingEmail$Outbound,
  BillingEmail$outboundSchema,
} from "../components/billingemail.js";

export type SetBillingEmailSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SetBillingEmailRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  billingEmail: BillingEmail;
};

/** @internal */
export type SetBillingEmailSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetBillingEmailSecurity$outboundSchema: z.ZodMiniType<
  SetBillingEmailSecurity$Outbound,
  SetBillingEmailSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function setBillingEmailSecurityToJSON(
  setBillingEmailSecurity: SetBillingEmailSecurity,
): string {
  return JSON.stringify(
    SetBillingEmailSecurity$outboundSchema.parse(setBillingEmailSecurity),
  );
}

/** @internal */
export type SetBillingEmailRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  BillingEmail: BillingEmail$Outbound;
};

/** @internal */
export const SetBillingEmailRequest$outboundSchema: z.ZodMiniType<
  SetBillingEmailRequest$Outbound,
  SetBillingEmailRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    billingEmail: BillingEmail$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      billingEmail: "BillingEmail",
    });
  }),
);

export function setBillingEmailRequestToJSON(
  setBillingEmailRequest: SetBillingEmailRequest,
): string {
  return JSON.stringify(
    SetBillingEmailRequest$outboundSchema.parse(setBillingEmailRequest),
  );
}
